import { expand } from 'uri-template-lite';
import { apiClient, ApiErrorResponseBody } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from './AlgorithmUrl';

export const checkBrokenReferencesQuery = (params: {
  algorithmIds: number[];
}) =>
  apiClient
    .get<ApiErrorResponseBody>(expand(AlgorithmUrl.BROKEN_REFERENCES, params))
    .then((response) => response.data);

export const useCheckBrokenReferencesQuery = createApiQueryHook(
  ['data-object-algorithm-check-broken-references'],
  checkBrokenReferencesQuery,
);
